<script setup lang="ts">
import { ConfirmDialogOptions } from '@models/ConfirmDialogOptions'
import i18n from 'src/i18n'
import { ref, useTemplateRef } from 'vue'
import ConfirmDialog from './ConfirmDialog.vue'

const confirmDialog = useTemplateRef('confirmDialog')

const title = ref('')
const message = ref('')
const warning = ref(false)
const acceptText = ref(i18n.t('accept'))
const cancelText = ref(i18n.t('cancel'))

let callback = () => {}

function open(options: ConfirmDialogOptions) {
  title.value = options.title
  message.value = options.message
  warning.value = !!options.warning
  acceptText.value = options.acceptText || i18n.t('accept')
  cancelText.value = options.cancelText || i18n.t('cancel')

  callback = options.onConfirm

  confirmDialog.value?.open()
}

function close() {
  confirmDialog.value?.close()
}

function onAccept() {
  callback()
  close()
}

defineExpose({
  open,
  close
})
</script>

<template>
  <ConfirmDialog
    ref="confirmDialog"
    :title="title"
    :message="message"
    :warning="warning"
    :ok-button-label="acceptText"
    :cancel-button-label="cancelText"
    @accept="onAccept"
  />
</template>

<style lang="scss" scoped></style>
